export const matchProfanity = (
  profanities: ReadonlyArray<string>,
  text: string
): string | undefined => {
  const splitString = text.toLowerCase().split(new RegExp(/\s+/));
  return profanities.find((value) => splitString.includes(value));
};
